import { useApp } from '../../context/AppContext';
import './Pages.css';

const Terms = () => {
  const { setCurrentView } = useApp();

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="btn btn-ghost" onClick={() => setCurrentView('upload')}>
          ← Back to Home
        </button>
        <h1>Terms of Service</h1>
      </div>

      <div className="page-content legal-content">
        <p className="legal-updated">Last updated: January 2025</p>

        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing and using GoSplitPDF ("the Service"), you agree to be bound by these
            Terms of Service. If you do not agree to these terms, please do not use the Service.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Description of Service</h2>
          <p>
            GoSplitPDF provides free online tools for PDF manipulation, including but not limited to:
            splitting, merging, signing, converting, and editing PDF documents. The Service is provided
            "as is" and "as available" without warranties of any kind.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. User Responsibilities</h2>
          <p>You agree to:</p>
          <ul>
            <li>Use the Service only for lawful purposes</li>
            <li>Not upload files that contain malware, viruses, or malicious code</li>
            <li>Not attempt to circumvent any security features of the Service</li>
            <li>Not use the Service to process documents you do not have the right to modify</li>
            <li>Not use automated systems or software to extract data from the Service</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Intellectual Property</h2>
          <p>
            You retain all rights to your documents. GoSplitPDF does not claim ownership of any
            content you process through the Service. The Service itself, including its design,
            features, and code, is protected by copyright and other intellectual property laws.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Limitation of Liability</h2>
          <p>
            GoSplitPDF shall not be liable for any indirect, incidental, special, consequential,
            or punitive damages resulting from your use of or inability to use the Service.
            This includes, but is not limited to, loss of data, profits, or business opportunities.
          </p>
        </section>

        <section className="legal-section">
          <h2>6. Service Availability</h2>
          <p>
            We strive to maintain high availability but do not guarantee uninterrupted access to
            the Service. We may modify, suspend, or discontinue any aspect of the Service at any
            time without notice.
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Changes to Terms</h2>
          <p>
            We reserve the right to modify these terms at any time. Continued use of the Service
            after changes constitutes acceptance of the modified terms. We encourage you to review
            these terms periodically.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Governing Law</h2>
          <p>
            These terms shall be governed by and construed in accordance with applicable laws,
            without regard to conflict of law principles.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Contact</h2>
          <p>
            If you have questions about these Terms of Service, please{' '}
            <button className="link-button" onClick={() => setCurrentView('contact')}>
              contact us
            </button>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;
